var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"box"}},[(_vm.value===_vm.zhi)?_c('div',{staticClass:"select",on:{"click":_vm.cancel}},[_c('a-icon',{attrs:{"type":"check"}})],1):_c('div',{staticClass:"no-select",on:{"click":_vm.select}})])}
var staticRenderFns = []

export { render, staticRenderFns }